import {assert} from 'Asserts';
import {DataFrame, DataFrameColumnDef} from 'data-frames/DataFrameTypes';

import findAndAssertColumn from './findAndAssertColumn';
import findColumn from './findColumn';

/**
 * Return a data frame with the specified column's def updated using a partial DataFrameColumnDef
 */
export default function updateColumnDef(
  dataFrame: DataFrame,
  columnSystemName: string,
  columnDefUpdate: Partial<DataFrameColumnDef>
): DataFrame {
  findAndAssertColumn(dataFrame, columnSystemName);

  assert(
    columnDefUpdate.systemName == null ||
      columnDefUpdate.systemName === columnSystemName ||
      findColumn(dataFrame, columnDefUpdate.systemName) == null,
    'Tried to update the name of a column with a name that already exists in the data frames',
    {
      oldColumnName: columnSystemName,
      newColumnName: columnDefUpdate.systemName,
      dataFrameColumns: dataFrame.columns,
    }
  );

  return {
    ...dataFrame,
    columns: dataFrame.columns.map((column) =>
      column.systemName === columnSystemName
        ? {
            ...column,
            ...columnDefUpdate,
          }
        : column
    ),
  };
}
